import React, { forwardRef } from 'react';
import '../../sections/SectionStyles.css';

const ProjectsSection = forwardRef(({ data, isActive }, ref) => {
	if (!data || !Array.isArray(data)) return null;

	return (
		<section 
			ref={ref}
			className={`projects-section section ${isActive ? 'active' : ''}`}
			data-section-index={4}
			style={{ opacity: isActive ? 1 : 0.95 }}
		>
			<div className="section-content">
				<div className="section-header">
					<h2 className="section-title">Personal Projects</h2>
					<p className="section-description">
						Innovative projects that showcase my technical skills and passion for learning
					</p>
				</div>

				<div className="projects-grid">
					{data.map((project) => (
						<div
							key={project.id}
							className="project-card"
						>
							<div className="project-header">
								<h3 className="project-title">{project.title}</h3>
								<div className="project-meta">
									<span className="project-organization">{project.organization}</span>
									<span className="project-duration">{project.duration}</span>
								</div>
							</div>
              
							<p className="project-description">{project.description}</p>
              
							{project.details && project.details.length > 0 && (
								<div className="project-details">
									<h5>Key Achievements:</h5>
									<ul>
										{project.details.map((detail, detailIndex) => (
											<li key={detailIndex}>{detail}</li>
										))}
									</ul>
								</div>
							)}
              
							{project.technologies && project.technologies.length > 0 && (
								<div className="project-technologies">
									<h5>Technologies:</h5>
									<div className="tech-tags">
										{project.technologies.map((tech, techIndex) => (
											<span key={techIndex} className="tech-tag">
												{tech}
											</span>
										))}
									</div>
								</div>
							)}

							{project.repo && (
								<a
									className="project-repo"
									href={project.repo}
									target="_blank"
									rel="noopener noreferrer"
								>
									View repository
								</a>
							)}
						</div>
					))}
				</div>

			</div>
		</section>
	);
});

ProjectsSection.displayName = 'ProjectsSection';

export default ProjectsSection;
